<template>
    <section class="payApvlRTable">
        <!-- el-table -->
        <el-table :data="tableData" border size="small" style="width: 100%; min-height: 200px;">
            <el-table-column align="center" :label="$t('payApvlSet.processName'/**流程名称*/)">
                <el-table-column align="center" prop="proName" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" :placeholder="$t('payApvlSet.inputFilter'/**关键字筛选*/)" v-model="vmProName" @change="handleChangeInputSelect" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" :label="$t('payApvlSet.status'/**状态*/)">
                <el-table-column align="center" prop="statusTxt" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-select :placeholder="$t('payApvlSet.select'/**请选择*/)" v-model="vmStatus" @change="handleChangeInputSelect" clearable>
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.codeitemid"
                                :label="item.codeitemname"
                                :value="item.codeitemid"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" :label="$t('payApvlSet.default'/**是否默认*/)">
                <el-table-column align="center" prop="defaultTxt" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-select :placeholder="$t('payApvlSet.select'/**请选择*/)" v-model="vmDefault" @change="handleChangeInputSelect" clearable>
                            <el-option
                                v-for="item in defaultOptions"
                                :key="item.codeitemid"
                                :label="item.codeitemname"
                                :value="item.codeitemid"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" :label="$t('payApvlSet.createTime'/**创建时间*/)">
                <el-table-column align="center" prop="createTime" class-name="own-cancal--lh">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" :placeholder="$t('payApvlSet.inputFilter'/*关键字筛选*/)" v-model="vmCreateTime" @change="handleChangeInputSelect" clearable/>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column align="center" fixed="right" :label="$t('payApvlSet.operation'/**操作*/)">
                <template slot-scope="scope">
                    <!-- slot 编辑按钮 禁用按钮 -->
                    <slot name="editButton" :row="scope.row"></slot>
                    <slot name="disableButton" :row="scope.row"></slot>
                </template>
            </el-table-column>
        </el-table>

        <!-- footer pagination -->
        <footer style="margin-top:5px;">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
        </footer>
    </section>
</template>

<script>
/**
 * API
 * - getPayApvlTableList     table列表
 * - postPayApvlCodeList     下拉列表
 */
import { getPayApvlTableList, postPayApvlCodeList } from '@/api/wage/paymentApproval'

export default {
    name: 'payApvlRTable',

    props: ['orgId'],

    watch: {
        orgId: {
            handler (newOrgId) {
                if (!!newOrgId) {
                    this.getPayApvlTableList()
                }
            },
            immediate: true,
        }
    },

    data() {
        return {
            /** el-table */
            tableData: [],
            currentPage: 1,     // 当前页
            pageSize: 10,       // 条/页
            total: 0,           // 总条目数

            vmProName: '',      // v-m 流程名称
            vmCreateTime: '',   // v-m 创建时间

            vmStatus: '',       // v-m 状态
            vmDefault: '',      // v-m 默认
            statusOptions: [],  // 下拉 状态
            defaultOptions: []  // 下拉 默认
        }
    },

    mounted() {
        this.postPayApvlCodeList('9011')
        this.postPayApvlCodeList('0090')
    },

    methods: {
        /** el-table */
        /**
         * @description API table列表
         */
        getPayApvlTableList() {
            let params = {
                type: 3,                        // 2 薪酬 3 付款通知 必填
                orgId: this.orgId,              // 组织机构id 必填
                proName: this.vmProName,        // 流程名称 模糊匹配
                status: this.vmStatus,          // 流程状态
                isDefault: this.vmDefault,      // 是否默认
                createTime: this.vmCreateTime,  // 创建时间
                current: this.currentPage,
                size: this.pageSize
            }
            getPayApvlTableList(params).then(res => {
                let data = res.data.data
                if (!data || data.records.lenght === 0) return
                this.tableData = Object.freeze(data.records)
                this.total = data.total
            })
        },

        /**
         * @description API 下拉列表
         */
        postPayApvlCodeList(codeSetId) {
            let params = {
                codeSetId,  // 状态 9011 是否默认 0090
            }
            postPayApvlCodeList(params).then(res => {
                let data = res.data.data
                if (!data || data.lenght === 0) return
                if (codeSetId == '9011') {
                    this.statusOptions = Object.freeze(data)
                } else {
                    this.defaultOptions = Object.freeze(data)
                }
            })
        },

        /**
         * @description 页面切换
         */
        handleCurrentChange(v) {
            this.currentPage = v
            this.getPayApvlTableList()
        },

        /**
         * @description 表头输入下拉搜索
         * @description 流程名称
         * @description 创建时间
         * @description 状态
         * @description 默认
         */
        handleChangeInputSelect(v) {
            this.currentPage = 1
            this.getPayApvlTableList()
        },

        /**
         * ! 父组件调用方法
         * @description 更新时
         */
        updateRTableData() {
            this.currentPage = 1
            this.getPayApvlTableList()
        }

    }

}

</script>

<style lang='scss'>
.payApvlRTable .el-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    padding: 10px 5px;
    .el-pager li { border: none !important; }
    .el-pagination__editor.el-input .el-input__inner { height: 24px; }
}

.payApvlRTable .el-table  {
    th > .cell { height: auto; }
    thead .own-cancal--lh div { line-height: 0; padding: 0; }
    .own-cancal--lh .el-select div { padding: 0; }
    .own-cancal--lh { padding: 10px; }
}
</style>
